module.exports = "/dist/assets/images/menu.svg";